//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MeetingsModal",
  components: {
    GenericModal
  },
  props: {
    syncedEmails: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleSelect(email) {
      this.$emit("select", false, email.nylasAccountId);
      this.hide();
    },
    show() {
      this.$refs.meetingsModal.show();
    },
    hide() {
      this.$refs.meetingsModal.hide();
    }
  }
});